import jQuery from 'jquery';

export const getCanvasDimensions = () => {
  const canvas = jQuery('#editor-canvas');

  const width = canvas.width();
  const height = canvas.height();
  const offset = canvas.offset();

  return { width, height, offset };
};

export const createSourceModeWrapper = () => {
  const sourceModeWrapper = document.createElement('div');
  sourceModeWrapper.className = 'source-mode-wrapper';

  document.body.appendChild(sourceModeWrapper);

  return sourceModeWrapper;
};

export const removeSourceModeWrapper = (sourceModeWrapper) => {
  document.body.removeChild(sourceModeWrapper);
};

export const clearFocusFromInlineText = () => { window.editor.keyController.clearFocus(); };



// WEBPACK FOOTER //
// ./src/ui/inline-text/source-mode-components/utils.js